export default __webpack_public_path__ + "static/media/orange_3.png";